import SortDirection, { type SortDirectionType } from '@rio-cloud/rio-uikit/utils/SortUtils';

import type { TableColumn } from '../../../enums/TableColumn';

export const calculateSortDir = (
    currentSortDir: SortDirectionType,
    sortBy: TableColumn,
    previousSortBy: TableColumn
): SortDirectionType => {
    if (sortBy === previousSortBy) {
        return currentSortDir === SortDirection.ASCENDING ? SortDirection.DESCENDING : SortDirection.ASCENDING;
    }
    return SortDirection.ASCENDING;
};
